import * as types from '../contents/actionTypes'
import toast from 'react-hot-toast'
export const receiveProducts = products => ({
    type : types.RECEIVE_PRODUCTS ,
    products
})


export const addToCart = productId => ({
    type : types.ADD_TO_CART ,
    productId
})


export const removeFromCart = productId => ({
    type : types.REMOVE_FROM_CART ,
    productId
})

export const receiveCart = cart => ({
    type : types.RECEIVE_CART ,
    cart
})


export const resetCart = cart => ({
    type : types.RESET_CART ,
    cart
})


/*export const addToUserCart = productId => ({
    type : types.ADD_TO_USER_CART ,
    productId
})*/

export const addToUserCart = (productId) => {
    return (dispatch, getState) => {

        const state = getState()
        const product = state.products[productId]
        const currentQty = state.cart[productId] || 0

        if (!product) return
        let orderInPreOrder = localStorage.getItem("orderInPreOrder") !== null && localStorage.getItem("orderInPreOrder") === 'true'
        if (!product.available && !orderInPreOrder) return

        let qty = currentQty + 1


        if (product.daily_stock_count_sens_status && !orderInPreOrder) {
            const max = parseInt(product.daily_stock_count)
            if (qty > max)
            {
                qty = max
                toast.error("امکان سفارش بیش از " + max + " عدد برای این محصول وجود ندارد")
            }
        }

        dispatch({
            type: types.ADD_TO_USER_CART,
            productId,
            qty
        })
    }
}



export const removeFromUserCart = productId => ({
    type : types.REMOVE_FROM_USER_CART ,
    productId
})
